import NoOpenHousesModal from "./NoOpenHousesModal";

export default NoOpenHousesModal;
